import { render, staticRenderFns } from "./shopheaderMobile.vue?vue&type=template&id=531301a6&scoped=true"
import script from "./shopheaderMobile.vue?vue&type=script&lang=js"
export * from "./shopheaderMobile.vue?vue&type=script&lang=js"
import style0 from "./shopheaderMobile.vue?vue&type=style&index=0&id=531301a6&prod&scoped=true&lang=css"
import style1 from "./shopheaderMobile.vue?vue&type=style&index=1&id=531301a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531301a6",
  null
  
)

export default component.exports